import List from 'list.js'

import { zoomToLocation } from '../controllers/members-map'
import {
  addClass,
  removeClass,
  hasClass,
  nodesToArray,
  distanceBetween,
  removeElement,
  setUrlParameter,
  getUrlParameter,
  isSecure,
  elementInViewport,
  isUndefined,
} from '../utils/helpers'
import { isAbove, addResize } from '../utils/breakpoints'

const filterLocationSelector = '.js-filterLocation'
const filterGeoButtonSelector = '.js-filterGeo'
// const distanceSelector = '.js-distance'
const viewButtonSelector = '.js-viewToggle'
const emptyStateSelector = '.js-listEmpty'
const formSelector = '.js-filterForm'
const inputSelector = '.js-filterInput'
const activeClass = 'is-active'
const hideClass = 'u-hiddenVisually'
const viewSelectors = ['list_view', 'map_view']

let El
let Form
let UserList
let GeoButton
let LocationButton
let ViewButtons
let CurrentView

export default class {
  constructor(el, options) {
    if (isUndefined(List)) {
      return
    }

    // return true

    options = this.options = Object.assign({}, this.options, options)

    this.el = el
    El = el

    GeoButton = el.querySelector(filterGeoButtonSelector)
    LocationButton = el.querySelector(filterLocationSelector)
    Form = el.querySelector(formSelector)

    if (LocationButton) {
      LocationButton.addEventListener(
        'click',
        this.sortLocationEvent.bind(this),
        false,
      )
    }

    ViewButtons = nodesToArray(el.querySelectorAll(viewButtonSelector))

    UserList = new List(el, {
      valueNames: [
        'js-filterOrt',
        'js-memberInfo',
        'js-filterLat',
        'js-filterLng',
      ],
      listClass: 'js-membersList',
      searchClass: 'js-filterInput',
    })

    const emptyStateEl = el.querySelector(emptyStateSelector)
    let isEmpty = false
    let matchLength = 0

    UserList.on('updated', (list) => {
      matchLength = list.matchingItems.length

      if (!isEmpty && matchLength === 0) {
        removeClass(emptyStateEl, hideClass)
        isEmpty = true
      } else if (isEmpty && matchLength > 0) {
        addClass(emptyStateEl, hideClass)
        isEmpty = false
      }
    })

    if (options.sort !== 'geo') {
      this.sortLocation(options.sort)
    }

    /* Initialize geolocation button or remove if not needed */
    if (options.map) {
      UserList.items.forEach((item) => {
        item.values({
          el: item.elm,
          id: item.elm.id,
        })
        if (item.values()['js-filterLat']) {
          item.elm.addEventListener(
            'click',
            (e) => {
              if (e.target.href) {
                return
              }
              this.activateMember(item.elm.id)
            },
            false,
          )
          item.elm.addEventListener(
            'keydown',
            (e) => {
              if (e.key === 'Enter' && !e.target.href) {
                this.activateMember(item.elm.id)
                e.preventDefault()
              }
            },
            false,
          )
        }
      })

      if (isSecure()) {
        if (options.sort === 'geo') {
          this.sortGeo()
        }

        GeoButton.addEventListener('click', this.sortGeo.bind(this), false)
      } else if (GeoButton) {
        removeElement(GeoButton)
      }

      Form.addEventListener(
        'submit',
        (e) => {
          e.preventDefault()
          return false
        },
        false,
      )
    }

    /**
     * [if description]
     * @param  {[type]} ViewButtons [description]
     * @return {[type]}             [description]
     */
    if (ViewButtons) {
      if (!options.map) {
        ViewButtons.forEach((button) => {
          removeElement(button)
        })
        return
      }

      nodesToArray(ViewButtons).forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            toggleView(button.getAttribute('data-target'))
          },
          false,
        )
        button.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Enter') {
              toggleView(button.getAttribute('data-target'))
            }
          },
          false,
        )
      })

      UserList.on('updated', () => {
        if (CurrentView !== viewSelectors[0]) {
          toggleView(viewSelectors[0], false)
        }
      })

      addResize(() => {
        if (isAbove('lg')) {
          viewSelectors.forEach((view) => {
            removeClass(document.getElementById(view), hideClass)
            addClass(ViewButtons[0], activeClass)
            removeClass(ViewButtons[1], activeClass)
            CurrentView = viewSelectors[0]
          })
        }
      })
    }

    this.checkParams()

    /* Input element */
    const inputEl = el.querySelector(inputSelector)
    if (inputEl) {
      inputEl.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Enter' || e.key === 'Escape') {
            inputEl.blur()
            e.preventDefault()
          }
        },
        false,
      )
    }
  }

  checkParams() {
    const member = getUrlParameter('member')

    if (member) {
      this.activateMember(member)
    }
  }

  activateMember(id) {
    zoomToLocation(id)
    toggleActiveMember(id)
  }

  sortLocationEvent(e) {
    this.sortLocation()

    e.preventDefault()
  }

  sortLocation(newOrder) {
    if (LocationButton) {
      const currentOrder = LocationButton.getAttribute('data-order')

      if (currentOrder === newOrder) {
        return
      }

      const buttonContent = LocationButton.querySelector('.js-buttonContent')
      const currentText = buttonContent.innerText
      const altText = LocationButton.getAttribute('data-alt')

      if (!newOrder) {
        newOrder = currentOrder === 'asc' ? 'desc' : 'asc'
      }

      UserList.sort('js-filterLat', {
        order: newOrder,
      })

      buttonContent.innerText = altText
      LocationButton.setAttribute('data-alt', currentText)
      LocationButton.setAttribute('data-order', newOrder)

      if (hasClass(GeoButton, activeClass)) {
        zoomToLocation()
      }

      addClass(LocationButton, activeClass)
      removeClass(GeoButton, activeClass)

      setUrlParameter('sort', newOrder)
    }
  }

  sortGeo(e) {
    let itemValues
    let distance
    // let distanceMetric

    GeoButton.setAttribute('disabled', 'true')
    addClass(GeoButton, 'is-loading')

    navigator.geolocation.getCurrentPosition(
      (position) => {
        UserList.items.forEach((item) => {
          itemValues = item.values()

          distance = distanceBetween(
            {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
            {
              lat: itemValues['js-filterLat'],
              lng: itemValues['js-filterLng'],
            },
          )

          item.values({
            distance: distance,
          })

          // if (distance > 10) {
          //   distanceMetric = 'mil'
          //   distance = distance / 10
          // } else if (distance > 1) {
          //   distanceMetric = 'kilometer'
          // } else {
          //   distance = distance * 1000
          //   distanceMetric = 'meter'
          // }

          // if (distance > 0) {
          //   item.elm.querySelector(distanceSelector).innerHTML =
          //     distance + ' ' + distanceMetric
          // } else {
          //   item.elm.querySelector(distanceSelector).innerHTML =
          //     'Mindre än 1 kilometer'
          // }
        })

        resetList()

        UserList.sort('distance', {
          order: 'asc',
        })

        zoomToLocation(UserList.items[0].values().id)

        setUrlParameter('sort', 'geo')

        GeoButton.removeAttribute('disabled')
        removeClass(GeoButton, 'is-loading')
        addClass(GeoButton, activeClass)

        if (LocationButton) {
          removeClass(LocationButton, activeClass)
        }
      },
      (error) => {
        const code = error.code
        let message =
          error.message || 'Något gick fel. Försök igen eller kontakta oss.'

        if (code === 1) {
          if (error.message.indexOf('secure') > -1) {
            message = 'Platstjänster fungerar inte just nu.'
            removeElement(GeoButton)
          } else {
            message =
              'Platstjänster är avstängda på den här enheten, i webbläsaren eller på den här hemsidan. Aktivera för att se din nuvarande plats.'
          }
        } else if (code === 3) {
          message = 'Platstjänsten tog för lång tid på sig och avbröts.'
        } else {
          message = message = 'Platstjänster fungerar inte just nu.'
        }

        if (e) {
          window.alert(message)
        }

        GeoButton.removeAttribute('disabled')
        removeClass(GeoButton, 'is-loading')
      },
      {
        timeout: 15000,
      },
    )

    if (e) {
      e.preventDefault()
    }
  }
}

function toggleActiveMember(id) {
  const activeMember = UserList.list.querySelector('.' + activeClass)

  if (activeMember) {
    removeClass(activeMember, activeClass)
  }

  if (id) {
    const el = document.getElementById(id)
    addClass(el, activeClass)

    setUrlParameter('member', id)
  }
}

export function toggleView(targetView, scroll = true) {
  if (targetView === CurrentView || isAbove('lg')) {
    return
  }

  let activeButton
  let newButton
  let otherView

  viewSelectors.forEach((view) => {
    if (view !== targetView) {
      otherView = view
    }
  })

  nodesToArray(ViewButtons).forEach((button) => {
    if (button.getAttribute('data-target') === targetView) {
      newButton = button
    } else {
      activeButton = button
    }
  })

  const showView = document.getElementById(targetView)
  const hideView = document.getElementById(otherView)

  if (hasClass(activeButton, activeClass) && showView && hideView) {
    removeClass(activeButton, activeClass)
    addClass(newButton, activeClass)

    removeClass(showView, hideClass)
    addClass(hideView, hideClass)

    if (scroll) {
      El.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }
}

/**
 * Reset list and show all items
 */
export function resetList() {
  UserList.search()
  toggleActiveMember()
}

/**
 * Scroll to member
 * @param  {String}   id
 * @param  {Function} callback
 */
export function scrollToMember(id, callback) {
  let el = id

  UserList.items.forEach((item) => {
    if (!item.visible() && item.values().id === id) {
      resetList()
    }
  })

  if (CurrentView !== viewSelectors[0]) {
    toggleView(viewSelectors[0], false)
  }

  if (el.nodeType === 1) {
    id = el.id
  } else {
    el = document.getElementById(id)
  }

  const targetEl = document.getElementById(id)
  if (targetEl) {
    targetEl?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })

    setTimeout(() => {
      toggleActiveMember(id)

      if (callback) {
        callback()
      }
    }, 300)
  }
}
